import { createSlice } from "@reduxjs/toolkit";
import {
  ContentManagementInitialStatus,
  GetContentData,
  GetSingleContentData,
} from "../../../types/contentManagment/contentManagment";
import {
  createPublicationAsync,
  getAllPublicationAsync,
  singPublicationAsync,
  updatePublicationAsync,
} from "./contentManagmentApi";

const initialState: ContentManagementInitialStatus<
  GetContentData,
  GetSingleContentData
> = {
  loading: false,
  manageLoading: false,
  ContentList: [],
  singleContentData: null,
  countContent: 0,
};

const contentManagementSlice = createSlice({
  name: "admin-publication",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createPublicationAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createPublicationAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createPublicationAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllPublicationAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllPublicationAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.ContentList = action.payload.data;
        state.countContent = action.payload.length;
      })
      .addCase(getAllPublicationAsync.rejected, (state) => {
        state.loading = false;
        state.ContentList = [];
        state.countContent = 0;
      });

    // update
    builder
      .addCase(updatePublicationAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updatePublicationAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updatePublicationAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // single
    builder
      .addCase(singPublicationAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleContentData = null;
      })
      .addCase(singPublicationAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleContentData = action.payload;
      })
      .addCase(singPublicationAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleContentData = null;
      });
  },
});

export default contentManagementSlice;
